/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { HttpActions, ResponseResolver } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of DocumentsController.
 */
export class DocumentsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /documents/{id}
     */
    public downloadFile<TResponse = unknown>(id: string, responseResolver?: ResponseResolver<TResponse>): Promise<TResponse> {
        return this.http.get<TResponse>(`/documents/${id}`, undefined, responseResolver);
    }
}
